export default "__VITE_ASSET__68f6ba19__"